import { useState } from 'react';
import { storageService } from '../services/storageService';

function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() =>
    storageService.get(key, initialValue)
  );

  const setValue = (value) => {
    setStoredValue((currentValue) => {
      const nextValue =
        typeof value === 'function' ? value(currentValue) : value;
      storageService.set(key, nextValue);
      return nextValue;
    });
  };

  return [storedValue, setValue];
}

export default useLocalStorage;
